import PassengerClass from "@CheckOrder/features/classPicker/components/PassengerClass";
import useDialog from "@Features/dialog/hooks/useDialog";
import {Colors} from "@Styles/Colors.style";
import IconInfo from "@Icons/IconInfo";
import PassengerClassPriceVariations from "@CheckOrder/features/classPicker/components/PassengerClassPriceVariations";
import Dialog from "@Features/dialog/components/Dialog";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

interface PassengerClassSelectProps {
    passengerClass: AvailablePassengerClassType,
    passengerId: number,
    handlePassengerClassSelect: (passengerClass: AvailablePassengerClassType) => () => void,
    isReturn: boolean,
}

function PassengerClassSelect({passengerClass, passengerId, handlePassengerClassSelect, isReturn}: PassengerClassSelectProps) {
    const {dialogRef, openModal} = useDialog(true, true)

    const moreInfo = (e) => {
        e.stopPropagation()
        openModal()
    }

    return (
        <button
            key={passengerClass.id}
            type="button"
            onClick={handlePassengerClassSelect(passengerClass)}
            className="passenger-class passenger-class__select-option"
        >
            <PassengerClass
                passengerId={passengerId}
                passengerClass={passengerClass}
                isReturn={isReturn}
                info={passengerClass?.groupId ? (
                    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                    <div onClick={moreInfo}>
                        <IconInfo fill={Colors.primaryColor}/>
                    </div>
                ) : undefined}
            />
            {!!passengerClass?.groupId && (
                <Dialog dialogRef={dialogRef}>
                    <PassengerClassPriceVariations
                        passengerClass={passengerClass}
                    />
                </Dialog>
            )}
        </button>
    )
}

export default PassengerClassSelect